import React from "react"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import CommentIcon from "components/atoms/_icons/CommentIcon"
import LikeIcon from "components/atoms/_icons/LikeIcon"

type WishItemStatusBoxProps = {
  commentsCount: number;
  likesCount: number;
  saveCount: number;
  shareCount: number;
}

export default function WishItemStatusBox(props: WishItemStatusBoxProps) {
  const { commentsCount, likesCount, saveCount, shareCount } = props

  return (
    <Container>
      <Stack direction="row" gap="4px">
        <span>{likesCount}</span>
        <LikeIcon/>
      </Stack>
      <Stack direction="row" gap="4px">
        <span>{commentsCount}</span>
        <CommentIcon/>
      </Stack>
      {/*<Stack direction="row" gap="4px">*/}
      {/*  <span>{saveCount}</span>*/}
      {/*  <BookmarkIcon/>*/}
      {/*</Stack>*/}
      {/*<Stack direction="row" gap="4px">*/}
      {/*  <span>{shareCount}</span>*/}
      {/*  <SendIcon/>*/}
      {/*</Stack>*/}
    </Container>
  )
}

const Container = styled(Stack)(({ theme }) => ({
  width: "100%",
  flexDirection: "row-reverse",
  gap: "8px",
  padding: "4px 0",
  fontSize: "1rem",
  color: theme.palette.gray["12"],

  "& svg": {
    width: "16px",
    height: "16px",
    stroke: theme.palette.gray["12"]
  },

  "& div:nth-of-type(2) svg": {
    stroke: "unset",
    fill: theme.palette.gray["12"]
  },

  "& span": {
    fontFamily: "VazirmatnFD, serif !important"
  }
}))
